// Restores Rebuy Smart Cart's pristine checkout button by reversing the TNC Terms &
// Conditions app's wrap-clone-hide pattern. TNC's intervention:
//   1. Wraps Rebuy's original `.rebuy-cart__checkout-button` in a <span>
//   2. Inside that span: hides the original (tags it `tac-co-original="true"`) and
//      inserts a static clone tagged `tac-co-cloned="true"` with an inline `onpointerdown`
//      whose hard-coded `'False' === 'False'` literal always alerts and `return false`s.
//
// Fix: inside Rebuy DOM, find every `[tac-co-original]`, clear its hiding styles/attrs,
// and replace the wrapping <span> with the recovered button — Rebuy's reactive Vue
// bindings (`v-on:click="checkout()"`, `v-bind:disabled="…"`, `checkoutLabel()`) keep
// working because we're handing back the original node, not a clone.
(function () {
  'use strict';

  var REBUY_SCOPES = ['.rebuy-cart', '.rebuy-cart__flyout', '.rebuy-widget'];
  var ORIGINAL_SELECTORS = REBUY_SCOPES.map(function (s) { return s + ' [tac-co-original]'; }).join(',');
  var CLONED_SELECTORS = REBUY_SCOPES.map(function (s) { return s + ' [tac-co-cloned]'; }).join(',');

  // Strips TNC's hiding styles/attrs from the recovered original button
  function unhide(node) {
    node.style.removeProperty('display');
    node.style.removeProperty('visibility');
    node.style.removeProperty('opacity');
    node.style.removeProperty('pointer-events');
    node.style.removeProperty('width');
    node.style.removeProperty('height');
    node.removeAttribute('hidden');
    node.removeAttribute('aria-hidden');
    node.removeAttribute('tac-co-original');
  }

  function sweep() {
    var originals = document.querySelectorAll(ORIGINAL_SELECTORS);
    for (var i = 0; i < originals.length; i++) {
      var original = originals[i];
      unhide(original);
      var wrapper = original.parentElement;
      if (wrapper && wrapper.tagName === 'SPAN' && wrapper !== document.body) {
        wrapper.replaceWith(original);
      }
    }
    var clones = document.querySelectorAll(CLONED_SELECTORS);
    for (var j = 0; j < clones.length; j++) {
      clones[j].remove();
    }
  }

  var observer = new MutationObserver(sweep);
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['tac-co-cloned', 'tac-co-original', 'onpointerdown', 'style']
  });

  var REBUY_EVENTS = [
    'rebuy:smartcart.ready',
    'rebuy:smartcart.show',
    'rebuy:smartcart.line-item-increase',
    'rebuy:smartcart.line-item-decrease',
    'rebuy:smartcart.line-item-removed',
    'rebuy:cart.change'
  ];
  for (var k = 0; k < REBUY_EVENTS.length; k++) {
    document.addEventListener(REBUY_EVENTS[k], sweep);
  }

  sweep();
})();
